import { render, staticRenderFns } from "./InviteGallery.vue?vue&type=template&id=5c2316e8&"
import script from "./InviteGallery.vue?vue&type=script&lang=js&"
export * from "./InviteGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports